import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import '@emotion/react';
import '@emotion/styled';

import './lib/util/tools';
import { initLibSettings } from './lib/libSettings';
import store, { persistor } from './lib/store';

import { GlobalClassesEnum } from './assets/scss/globalClasses/globalClasses.constants';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import App from './App';
import { GOOGLE_TAG_MANAGER_ID } from './constants';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import './assets/scss/globalClasses/globalClasses.scss';

window.GlobalClassesEnum = GlobalClassesEnum;

initLibSettings();

if (GOOGLE_TAG_MANAGER_ID) { // For the local env, it will be null by default. And this block will not be triggered
  TagManager.initialize({ gtmId: GOOGLE_TAG_MANAGER_ID });
}

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
);

reportWebVitals();
